const leftNavKitchenAdmin = [
  {
    order: 1,
    name: 'Home',
    route: '/KitchenAdminHome',
    expanded: false,
    icon: <i className="mdi mdi-pin"></i>
  },
];

export default leftNavKitchenAdmin;
